// extracted by mini-css-extract-plugin
export var avatarContainer = "_ey-0";
export var gray = "_ey-f";
export var green = "_ey-c";
export var icon = "_ey-9";
export var image = "_ey-1";
export var lg = "_ey-6";
export var md = "_ey-5";
export var presenceDot = "_ey-b";
export var red = "_ey-d";
export var sm = "_ey-4";
export var status = "_ey-a";
export var xl = "_ey-7";
export var xs = "_ey-3";
export var xxl = "_ey-8";
export var xxs = "_ey-2";
export var yellow = "_ey-e";